package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.User
import fr.manyverse.app.domain.repository.AuthRepository

class SignInAnonymouslyUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(): Result<User> = authRepository.signInAnonymously()
}
